import { SxProps, Theme } from '@mui/material';

export const MethodButtonStyles = (
  theme: Theme,
  isSelected: boolean,
  variant: 'compact' | 'journey' = 'compact'
): Record<string, SxProps<Theme>> => {
  if (variant === 'journey') {
    const shadow = `0px 4px 2px ${theme.customColors?.elevation ?? 'rgba(183, 185, 190, 1)'}`;
    return {
      mainContainer: {
        bgcolor: theme.palette.background.paper,
        // Figma 1680:5520 (normal) e 1680:5147 (selecionado): a seleção é uma
        // borda real de 2px em `brand/main`, não um anel de sombra. A borda
        // transparente no estado normal evita o salto de 2px ao selecionar.
        border: '2px solid',
        borderColor: isSelected ? theme.customColors.brandMain : 'transparent',
        borderRadius: '16px',
        boxShadow: shadow,
        color: theme.palette.text.primary,
        display: 'flex',
        flex: '1 1 0',
        flexDirection: 'column',
        fontSize: theme.typography.body1.fontSize,
        fontWeight: 500,
        // 8 + ícone 64 + rótulo 24 + 8 = 104.
        gap: 0,
        minHeight: 104,
        minWidth: 0,
        px: '8px',
        py: '8px',
        textTransform: 'none',
        '&:hover': {
          bgcolor: theme.palette.background.paper,
          borderColor: isSelected ? theme.customColors.brandMain : theme.palette.divider,
          boxShadow: shadow
        }
      }
    };
  }
  return {
    mainContainer: {
      width: '80px',
      fontSize: '12px',
      borderRadius: '0.5rem',
      padding: '0',
      paddingBlock: '0.3rem',
      display: 'flex',
      flexDirection: 'column',
      color: '#ffffff',
      borderColor: isSelected ? theme.palette.primary.main : theme.palette.primary.contrastText,
      backgroundColor: isSelected ? theme.palette.primary.main : 'transparent',
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    }
  };
};
